<style scoped>
@import url("../assets/css/result.css");
</style>

<template>
    <div class="home-content common-home-content" v-show="show">
        <div class="ice_bg space_pl space_pr space_pb" v-show="pass_show">
            <h2 class="ce-exam-title font_3 ">{{department_label}}测验</h2>
            <section class="ce-examResult-container clearfix">
                <p class="ce-exam-result font_4">测验结果</p>
                <p class="tc"><span class="ce-exam-score">恭喜您！本次得分为:</span><span class="ce-exam-score-full">100&nbsp;分</span></p>
                <div class="ce-exam-over">
                    <button @click="goBack(-2)" class="btn_1 a">完成</button>
                </div>
            </section>
        </div>
        <div class="ice_bg space_pl space_pr space_pb" v-show="!pass_show">
            <h2 class="ce-exam-title font_3 ">{{department_label}}测验</h2>
            <p class="ce-exam-result font_4">测验结果</p>
            <p class="ce-exam-score">本次得分为:<span>{{scores}}&nbsp;分</span></p>
            <p class="ce-exam-wrongTip mb30">
                第
                <span v-for="(child, index) in incorrect_questions" :key="index"><span v-if="index != 0">,</span>{{child}}</span>
                题答案不正确
            </p>
            <div class="ce-exam-submitbutton clearfix">
                <div class="ce-exam-again fl">
                    <button class="btn_1 a" @click="goBack(-1)">再来一次</button>
                </div>
                <div class="ce-exam-finish fl">
                    <button class="btn_1 a" @click="goBack(-2)">完成</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      results: [],
      show: false,
      department_label:'',
      department_pinyin: 'neike',
      incorrect_questions: [],
      seed: 'zrul3j5im9ks8jtchv71lbeot72r95pz',
      scores: 0,
      pass_show: true
    };
  },
  created() {
    this.loadinti();
    window.appBack = ()=> this.pageback();
    
  },
  methods: {
    loadinti(){
        var that = this;
        that.scores = that.$route.params.scores;
        that.incorrect_questions = that.$route.params.incorrect_questions;
        that.department_label = that.$route.params.department.label;
        that.pass_show = that.scores >= 100;
        that.show = true;
    },
    goBack(speed){
        window.history.go(speed);
    },
    pageback(){
        if(this.pass_show){
            window.history.go(-2);
        }else{
            window.history.back();
        }
        return true;
    }  
  }
}
</script>

